import { __extends } from "tslib";
import * as React from 'react';
import { DeprecatedSelect } from '../../../primitives';
import { DeprecatedText } from '../../../deprecated-typography';
import { namespacedClassnames } from '../../../common';
import { renderFlatCatName, categoryOptionRenderer } from '../common';
var CategorySelector = /** @class */ (function (_super) {
    __extends(CategorySelector, _super);
    function CategorySelector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (val) {
            var selectedCat = _this.props.categories.filter(function (i) { return i.id === val.value; })[0];
            _this.props.onChange(selectedCat);
        };
        return _this;
    }
    CategorySelector.prototype.render = function () {
        var props = this.props;
        var options = props.categories.map(function (i) { return renderFlatCatName(i); });
        var selectedVal = props.value ? renderFlatCatName(props.value) : null;
        var classes = namespacedClassnames('category-selector', { 'with-error': !!props.errorMsg });
        return (React.createElement("div", { className: classes },
            React.createElement(DeprecatedSelect, { value: selectedVal, options: options, onChange: this.onChange, placeholder: props.placeholder, optionRenderer: categoryOptionRenderer, valueRenderer: categoryOptionRenderer, onOpen: props.onOpen, onClose: props.onClose, disabled: props.disabled || false, menuPlacement: props.menuPlacement, bringMenuToFront: props.bringMenuToFront, useSelectV3: props.useSelectV3, noResultsText: props.noResultsText }),
            props.errorMsg ? React.createElement(DeprecatedText, { type: 't4a', className: 'validation-error' }, props.errorMsg) : null));
    };
    return CategorySelector;
}(React.PureComponent));
export { CategorySelector };
//# sourceMappingURL=category-selector.comp.js.map